'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addD2Context;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addContext = require('./addContext');

var _addContext2 = _interopRequireDefault(_addContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addD2Context(Component) {
    return (0, _addContext2.default)(Component, { d2: _propTypes2.default.object });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-core/component-helpers/addD2Context.js
// module id = 1776
// module chunks = 0